import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Novedades.css';
import './PanelNovedades.css';
import axios from 'axios';

const PanelNovedades = () => {
  const navigate = useNavigate();
  const getCurrentDateTimeLocal = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };
  const formatDateTimeLocal = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().slice(0, 16);
  };
  const [view, setView] = useState('menu'); // menu | crear | editar | eliminar
  const [noticias, setNoticias] = useState([]);

  const fetchNoticias = async (forceRefresh = false) => {
    try {
      setRefreshing(true);
      const url = forceRefresh
        ? `${process.env.REACT_APP_API_URL}/noticias/?_t=${Date.now()}`
        : `${process.env.REACT_APP_API_URL}/noticias/`;

      const res = await axios.get(url);
      const noticiasData = res.data.results || res.data;
      setNoticias(noticiasData);
    } catch (err) {
      console.error('Error cargando noticias', err);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchNoticias();
  }, []);

  const [titulo, setTitulo] = useState('');
  const [fechaPublicacion, setFechaPublicacion] = useState(getCurrentDateTimeLocal());
  const [imagen, setImagen] = useState(null);
  const [imagenPreview, setImagenPreview] = useState('');
  const [galeria, setGaleria] = useState([]);
  const [galeriaPreview, setGaleriaPreview] = useState([]);
  const [previewContent, setPreviewContent] = useState('');
  const contenidoRef = useRef();
  const [error, setError] = useState('');
  const [editId, setEditId] = useState(null);
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const resetForm = () => {
    setTitulo('');
    setFechaPublicacion(getCurrentDateTimeLocal());
    setImagen(null);
    setImagenPreview('');
    setGaleria([]);
    setGaleriaPreview([]);
    setPreviewContent('');
    setError('');
    setEditId(null);
    setShowImageUpload(false);
    setShowPreview(false);

    if (contenidoRef.current) {
      contenidoRef.current.innerHTML = '';
    }
  };

  const insertImageInEditor = (imageData) => {
    const editor = contenidoRef.current;
    if (!editor) return;

    const selection = window.getSelection();
    const range = selection.getRangeAt(0);

    const img = document.createElement('img');
    img.src = imageData;
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.borderRadius = '8px';
    img.style.margin = '10px 0';

    range.deleteContents();
    range.insertNode(img);

    range.setStartAfter(img);
    range.setEndAfter(img);
    selection.removeAllRanges();
    selection.addRange(range);

    editor.focus();
    setPreviewContent(editor.innerHTML);
  };

  const handleEditorImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        insertImageInEditor(reader.result);
      };
      reader.readAsDataURL(file);
    }
    setShowImageUpload(false);
  };

  const insertImageFromURL = () => {
    const url = prompt('Ingresa la URL de la imagen:');
    if (url && url.trim()) {
      insertImageInEditor(url.trim());
    }
  };

  const insertImageFromFile = () => {
    setShowImageUpload(true);
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    if (contenidoRef.current) {
      contenidoRef.current.focus();
      setPreviewContent(contenidoRef.current.innerHTML);
    }
  };

  const insertLink = () => {
    const url = prompt('Ingresa la URL del enlace:');
    if (url && url.trim()) {
      execCommand('createLink', url.trim());
    }
  };

  const insertList = (type) => {
    execCommand(type === 'ordered' ? 'insertOrderedList' : 'insertUnorderedList');
  };

  const insertHeading = (level) => {
    execCommand('formatBlock', `<h${level}>`);
  };

  const insertQuote = () => {
    execCommand('formatBlock', '<blockquote>');
  };

  const insertTable = () => {
    const rows = prompt('Numero de filas:', '3');
    const cols = prompt('Numero de columnas:', '3');
    if (rows && cols) {
      let tableHTML = '<table style="border-collapse: collapse; width: 100%; margin: 10px 0;">';
      for (let i = 0; i < parseInt(rows); i++) {
        tableHTML += '<tr>';
        for (let j = 0; j < parseInt(cols); j++) {
          tableHTML += '<td style="border: 1px solid #ddd; padding: 8px; text-align: left;">Celda</td>';
        }
        tableHTML += '</tr>';
      }
      tableHTML += '</table>';

      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const div = document.createElement('div');
      div.innerHTML = tableHTML;
      range.deleteContents();
      range.insertNode(div.firstChild);
      if (contenidoRef.current) {
        contenidoRef.current.focus();
        setPreviewContent(contenidoRef.current.innerHTML);
      }
    }
  };

  const handleImagenFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagen(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleGaleriaFile = (i, e) => {
    const file = e.target.files[0];
    if (file) {
      const newGaleria = [...galeria];
      newGaleria[i] = file;
      setGaleria(newGaleria);

      const reader = new FileReader();
      reader.onloadend = () => {
        const newGaleriaPreview = [...galeriaPreview];
        newGaleriaPreview[i] = reader.result;
        setGaleriaPreview(newGaleriaPreview);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddFoto = () => {
    setGaleria([...galeria, null]);
    setGaleriaPreview([...galeriaPreview, '']);
  };

  const handleRemoveFoto = (i) => {
    setGaleria(galeria.filter((_, idx) => idx !== i));
    setGaleriaPreview(galeriaPreview.filter((_, idx) => idx !== i));
  };

  const startEdit = (noticia) => {
    setEditId(noticia.id);
    setTitulo(noticia.titulo);
    setFechaPublicacion(formatDateTimeLocal(noticia.fecha_publicacion));
    setImagen(noticia.imagen_principal_url);
    setImagenPreview(noticia.imagen_principal_url);

    const imagenesExtraUrls = noticia.imagenes_extra_data
      ? noticia.imagenes_extra_data.map((img) => img.imagen)
      : [];
    setGaleria(imagenesExtraUrls.length > 0 ? imagenesExtraUrls : []);
    setGaleriaPreview(imagenesExtraUrls.length > 0 ? imagenesExtraUrls : []);

    setTimeout(() => {
      if (contenidoRef.current) {
        contenidoRef.current.innerHTML = noticia.contenido;
        setPreviewContent(noticia.contenido);
      }
    }, 100);
    setView('editar');
  };

  const handlePublicar = async (e) => {
    e.preventDefault();
    const contenido = contenidoRef.current.innerHTML.trim();
    if (!titulo || !imagen || !contenido) {
      setError('Todos los campos principales son obligatorios.');
      return;
    }

    const formData = new FormData();
    formData.append('titulo', titulo);
    formData.append('contenido', contenido);
    formData.append('fecha_publicacion', `${fechaPublicacion}:00`);

    if (typeof imagen === 'string') {
      // keep existing image
    } else if (imagen instanceof File) {
      formData.append('imagen_principal', imagen);
    }

    if (view === 'editar' && editId) {
      formData.append('titulo', titulo);
      formData.append('contenido', contenido);
    }

    const imagenesExtra = galeria.filter((item) => item instanceof File);
    imagenesExtra.forEach((file) => {
      formData.append('imagenes_extra', file);
    });

    try {
      const headers = {
        'Content-Type': 'multipart/form-data'
      };

      if (view === 'editar' && editId) {
        await axios.put(`${process.env.REACT_APP_API_URL}/noticias/${editId}/`, formData, { headers });
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/noticias/`, formData, { headers });
      }

      const res = await axios.get(`${process.env.REACT_APP_API_URL}/noticias/?_t=${Date.now()}`);
      const noticiasData = res.data.results || res.data;
      setNoticias(noticiasData);
      resetForm();
      setView('menu');
      navigate('/novedades');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error('Error al publicar noticia', err);
      setError('Error al guardar la noticia.');
    }
  };

  const handleEliminar = async (id) => {
    if (window.confirm('Seguro que deseas eliminar esta noticia?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/noticias/${id}/`);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/noticias/?_t=${Date.now()}`);
        const noticiasData = res.data.results || res.data;
        setNoticias(noticiasData);
      } catch (err) {
        console.error('Error eliminando noticia', err);
        alert('No se pudo eliminar la noticia');
      }
    }
  };

  const renderForm = () => (
    <div className="panel-form-layout">
      <form onSubmit={handlePublicar} className="panel-form">
        <label className="panel-label">Titulo *</label>
        <input className="panel-input" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />

        <label className="panel-label">Fecha de publicacion *</label>
        <input
          className="panel-input"
          type="datetime-local"
          value={fechaPublicacion}
          onChange={(e) => setFechaPublicacion(e.target.value)}
          required
        />

        <label className="panel-label">Imagen principal *</label>
        <input className="panel-input" type="file" accept="image/*" onChange={handleImagenFile} />
        {imagenPreview && (
          <img
            src={imagenPreview}
            alt="preview"
            style={{ width: 180, height: 120, objectFit: 'cover', borderRadius: 8, marginBottom: 12, border: '1.5px solid #b0bec5' }}
          />
        )}

        <label className="panel-label">Texto de la noticia *</label>

        <div className="editor-toolbar">
          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={() => execCommand('bold')} title="Negrita">
              <strong>B</strong>
            </button>
            <button type="button" className="toolbar-btn" onClick={() => execCommand('italic')} title="Cursiva">
              <em>I</em>
            </button>
            <button type="button" className="toolbar-btn" onClick={() => execCommand('underline')} title="Subrayado">
              <u>U</u>
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={() => insertHeading(1)} title="Titulo 1">
              H1
            </button>
            <button type="button" className="toolbar-btn" onClick={() => insertHeading(2)} title="Titulo 2">
              H2
            </button>
            <button type="button" className="toolbar-btn" onClick={() => insertHeading(3)} title="Titulo 3">
              H3
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={() => insertList('unordered')} title="Lista con vi�etas">
              � Lista
            </button>
            <button type="button" className="toolbar-btn" onClick={() => insertList('ordered')} title="Lista numerada">
              1. Lista
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={insertLink} title="Insertar enlace">
              Link
            </button>
            <button type="button" className="toolbar-btn" onClick={insertQuote} title="Insertar cita">
              Cita
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={insertTable} title="Insertar tabla">
              Tabla
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={insertImageFromFile} title="Insertar imagen desde archivo">
              Imagen
            </button>
            <button type="button" className="toolbar-btn" onClick={insertImageFromURL} title="Insertar imagen desde URL">
              URL Imagen
            </button>
          </div>

          <div className="toolbar-group">
            <button type="button" className="toolbar-btn" onClick={() => execCommand('justifyLeft')} title="Alinear izquierda">
              Izq
            </button>
            <button type="button" className="toolbar-btn" onClick={() => execCommand('justifyCenter')} title="Centrar">
              Centrar
            </button>
            <button type="button" className="toolbar-btn" onClick={() => execCommand('justifyRight')} title="Alinear derecha">
              Der
            </button>
          </div>
        </div>

        <input
          type="file"
          accept="image/*"
          onChange={handleEditorImageUpload}
          style={{ display: 'none' }}
          id="editor-image-upload"
        />
        {showImageUpload && (
          <div className="image-upload-overlay">
            <div className="image-upload-modal">
              <h4>Selecciona una imagen</h4>
              <input type="file" accept="image/*" onChange={handleEditorImageUpload} autoFocus />
              <button type="button" onClick={() => setShowImageUpload(false)} className="cancel-btn">
                Cancelar
              </button>
            </div>
          </div>

        )}

        <div
          className="panel-editor"
          ref={contenidoRef}
          contentEditable
          onInput={() => setPreviewContent(contenidoRef.current?.innerHTML || '')}
          style={{ minHeight: 120, border: '1px solid #ccc', borderRadius: 8, padding: 12, marginBottom: 16, background: '#fff' }}
          placeholder="Escribe el contenido aqui..."
        />

        <label className="panel-label">Galeria de fotos (opcional)</label>
        <div className="panel-galeria-preview">
          {galeriaPreview.map((foto, i) =>
            foto ? <img key={i} src={foto} alt={`galeria${i}`} /> : null
          )}
        </div>
        {galeria.map((foto, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <input type="file" accept="image/*" onChange={(e) => handleGaleriaFile(i, e)} />
            {galeria.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemoveFoto(i)}
                style={{ color: '#d32f2f', fontWeight: 700, background: 'none', border: 'none', cursor: 'pointer' }}
              >
                X
              </button>
            )}
          </div>
        ))}
        <button type="button" className="leer-mas-btn" style={{ marginBottom: 16 }} onClick={handleAddFoto}>
          Agregar foto
        </button>

        {error && <div style={{ color: '#d32f2f', marginBottom: 12 }}>{error}</div>}
        <div className="panel-form-actions">
          <button
            type="button"
            className="leer-mas-btn panel-preview-btn"
            onClick={() => setShowPreview(true)}
          >
            Vista previa
          </button>
          <button type="submit" className="leer-mas-btn panel-submit-btn">
            {view === 'editar' ? 'Guardar cambios' : 'Publicar'}
          </button>
          <button
            type="button"
            className="leer-mas-btn panel-cancel-btn"
            onClick={() => {
              resetForm();
              setView('menu');
            }}
          >
            Cancelar
          </button>
        </div>
      </form>

      {showPreview && (
        <div className="panel-preview-overlay" onClick={() => setShowPreview(false)}>
          <div className="panel-preview-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="panel-preview-close" onClick={() => setShowPreview(false)}>
              Cerrar
            </button>
            <div className="panel-preview-hero">
              {imagenPreview ? (
                <img src={imagenPreview} alt="Vista previa" />
              ) : (
                <div className="panel-preview-placeholder">Sin imagen</div>
              )}
            </div>
            <div className="panel-preview-body">
              <h3>{titulo || 'Titulo de la noticia'}</h3>
              <p className="noticia-fecha">
                {fechaPublicacion
                  ? new Date(`${fechaPublicacion}:00`).toLocaleString('es-AR')
                  : 'Fecha sin definir'}
              </p>
              <div
                className="panel-preview-content"
                dangerouslySetInnerHTML={{
                  __html: previewContent || '<p>Escribi el contenido para ver la vista previa.</p>'
                }}
              />
              {galeriaPreview.filter(Boolean).length > 0 && (
                <div className="panel-preview-gallery">
                  {galeriaPreview.filter(Boolean).map((foto, i) => (
                    <img key={`${foto}-${i}`} src={foto} alt={`Galeria ${i + 1}`} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <section className="novedades-section">
      <div className="container" style={{ maxWidth: 800 }}>
        <h2 className="section-title">Panel de Novedades</h2>
        {view === 'menu' && (
          <div className="panel-menu-wrap">
            <div className="panel-menu-grid">
            <button className="panel-menu-card panel-menu-card-primary" onClick={() => { resetForm(); setView('crear'); }}>
              <strong>Crear noticia</strong>
              <span>Publicar una nueva novedad</span>
            </button>
            <button className="panel-menu-card panel-menu-card-success" onClick={() => setView('select-editar')}>
              <strong>Editar noticia</strong>
              <span>Modificar una noticia existente</span>
            </button>
            <button className="panel-menu-card panel-menu-card-danger" onClick={() => setView('eliminar')}>
              <strong>Eliminar noticia</strong>
              <span>Quitar una noticia publicada</span>
            </button>
            <button
              className="panel-menu-card panel-menu-card-info"
              onClick={() => fetchNoticias(true)}
              disabled={refreshing}
            >
              <strong>{refreshing ? 'Actualizando...' : 'Actualizar lista'}</strong>
              <span>Recargar noticias desde el servidor</span>
            </button>
          </div>
          </div>
        )}
        {view === 'crear' && (
          <>
            <h3 style={{ marginBottom: 24, color: '#1976d2' }}>Crear nueva noticia</h3>
            {renderForm()}
          </>
        )}
        {view === 'select-editar' && (
          <div style={{ margin: '2rem 0' }}>
            <h3 style={{ marginBottom: 24, color: '#43a047' }}>Selecciona una noticia para editar</h3>
            <div className="noticias-grid">
              {noticias.map((n) => (
                <div key={n.id} className="noticia-card" style={{ cursor: 'pointer' }} onClick={() => startEdit(n)}>
                  <div className="noticia-imagen"><img src={n.imagen_principal_url} alt={n.titulo} /></div>
                  <div className="noticia-contenido">
                    <h4 className="noticia-titulo">{n.titulo}</h4>
                    <p className="noticia-fecha">{n.fecha_publicacion}</p>
                  </div>
                </div>
              ))}
            </div>
            <button
              type="button"
              className="leer-mas-btn"
              style={{ background: '#b0bec5', color: '#222', marginTop: 24 }}
              onClick={() => setView('menu')}
            >
              Volver
            </button>
          </div>

        )}
        {view === 'editar' && (
          <>
            <h3 style={{ marginBottom: 24, color: '#43a047' }}>Editar noticia</h3>
            {renderForm()}
          </>
        )}
        {view === 'eliminar' && (
          <div style={{ margin: '2rem 0' }}>
            <h3 style={{ marginBottom: 24, color: '#d32f2f' }}>Eliminar noticia</h3>
            <div className="noticias-grid">
              {noticias.map((n) => (
                <div key={n.id} className="noticia-card">
                  <div className="noticia-imagen"><img src={n.imagen_principal_url} alt={n.titulo} /></div>
                  <div className="noticia-contenido">
                    <h4 className="noticia-titulo">{n.titulo}</h4>
                    <p className="noticia-fecha">{n.fecha_publicacion}</p>
                    <button className="leer-mas-btn" style={{ background: '#d32f2f', marginTop: 12 }} onClick={() => handleEliminar(n.id)}>
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <button
              type="button"
              className="leer-mas-btn"
              style={{ background: '#b0bec5', color: '#222', marginTop: 24 }}
              onClick={() => setView('menu')}
            >
              Volver
            </button>
          </div>

        )}
      </div>
    </section>
  );
};

export default PanelNovedades;
